import * as Payments from './payments/';
import * as Content from './content';
import * as Auth from './auth';
import * as Integrations from './integrations';
import { lazyWithRetry } from '../utils/lazy-with-retry';
import FeatureUnavailable from '../components/feature-unavailable';

const NotFound = lazyWithRetry(() => import('./not-found'), 'NotFound');
const EngageRoutes = lazyWithRetry(() => import('./engage'), 'EngageRoutes');
const PublicRoutes = lazyWithRetry(() => import('./public'), 'PublicRoutes');
const Onboarding = lazyWithRetry(() => import('./onboarding/onboarding'), 'Onboarding');
const Individual = lazyWithRetry(() => import('./onboarding/individual'), 'Individual');
const OnboardingInterview = lazyWithRetry(
  () => import('./onboarding/interview'),
  'OnboardingInterview'
);
const Calendar = lazyWithRetry(() => import('./calendar/calendar'), 'Calendar');
const Account = lazyWithRetry(() => import('./account/index'), 'Account');
const Workspace = lazyWithRetry(() => import('./workspace/index'), 'Workspace');
const Org = lazyWithRetry(() => import('./org/index'), 'Org');
const Dashboard = lazyWithRetry(() => import('./dashboard/index'), 'Dashboard');
const Analytics = lazyWithRetry(() => import('./analytics/index'), 'Analytics');
const TrialStart = lazyWithRetry(() => import('./trial-start/index'), 'TrialStart');
const Kanban = lazyWithRetry(() => import('./kanban/index'), 'Kanban');
const KnowledgeBase = lazyWithRetry(() => import('./knowledge-base/index'), 'KnowledgeBase');
const UserChallenges = lazyWithRetry(() => import('./user-challenges/index'), 'UserChallenges');
const Mcp = lazyWithRetry(() => import('./mcp/mcp-live'), 'Mcp');
const ContentRadarRoutes = lazyWithRetry(() => import('./content-radar/index'), 'ContentRadarRoutes');
const AppsumoActivate = lazyWithRetry(() => import('./appsumo/activate'), 'AppsumoActivate');
const WorkspaceCreativeStudio = lazyWithRetry(
  () => import('./creative-studio/index'),
  'WorkspaceCreativeStudio'
);

export {
  NotFound,
  Payments,
  Content,
  Auth,
  Integrations,
  Org,
  Dashboard,
  EngageRoutes,
  PublicRoutes,
  Onboarding,
  Individual,
  OnboardingInterview,
  Calendar,
  Account,
  Workspace,
  Analytics,
  TrialStart,
  Kanban,
  KnowledgeBase,
  UserChallenges,
  FeatureUnavailable,
  Mcp,
  ContentRadarRoutes,
  WorkspaceCreativeStudio,
  AppsumoActivate,
};
